import { Component, OnInit } from '@angular/core';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import {Subject, Observable} from 'rxjs';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-webcam',
  templateUrl: './webcam.component.html',
  styleUrls: ['./webcam.component.css'],
  providers: [ConfirmationService]
})
export class WebcamComponent implements OnInit {
  
  showCapture:boolean = false;

  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef, public confirmationService: ConfirmationService) { }
  
  public showWebcam = true;
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();

  public ngOnInit(): void {
    setTimeout(() => {
      this.showCapture = true;
    }, 3000);
  }

  public capturePhoto(): void {
    this.trigger.next();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    if(error.message == "Requested device not found") {
      this.confirmationService.confirm({
        message: 'Device not found, Check device whether connected properly?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.ref.close();
        },
        rejectVisible: false
      });
    }
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
  }

  public captureNew() {
    this.webcamImage = null;
    this.showCapture = false;
    setTimeout(() => {
      this.showCapture = true;
    }, 3000);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public confirmImg() {
    this.ref.close(this.webcamImage);
  }
}
